/**
 * Configurateur kit — reproduction du parcours Relentless Microcement
 * (surface → effet → couleur → primaires → finition → upgrade)
 */
(function () {
  'use strict';

  var STEP_ORDER = [
    'size',
    'effect',
    'colour',
    'primer-area-one',
    'primer-area-two',
    'finish',
    'upgrade',
  ];

  var STEP_LABELS = {
    size: 'Surface',
    effect: 'Effet',
    colour: 'Couleur',
    'primer-area-one': 'Primaire sol',
    'primer-area-two': 'Primaire murs',
    finish: 'Finition',
    upgrade: 'Upgrade',
  };

  var ARROW_SVG =
    '<svg viewBox="0 0 20 15" aria-hidden="true"><path d="M19.558.44a1.5 1.5 0 0 1 0 2.122L8.311 13.81a1.6 1.6 0 0 1-2.264 0L.458 8.22a1.6 1.6 0 0 1 2.263-2.263l5.2 5.2 9.9-9.9a1.5 1.5 0 0 1 2.121 0Z"/></svg>';

  var CONTINUE_ARROW =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 14" aria-hidden="true"><path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7H1m18 0-6-6m6 6-6 6"/></svg>';

  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      return (amount || 0).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function calcProductPrice(product, area) {
    if (!product || !product.coverage || !('price' in product) || area <= 0) return null;
    var coverage = parseFloat(product.coverage);
    var price = parseFloat(product.price);
    if (coverage <= 0 || isNaN(coverage) || isNaN(price)) return null;
    var qty = Math.ceil(area / coverage);
    var total = qty * price;
    if (product.toners && Array.isArray(product.toners)) {
      product.toners.forEach(function (t) {
        var base = parseFloat(t.base_price) || 0;
        var req = parseFloat(t.toners_required) || 0;
        if (base > 0 && req > 0) {
          total += Math.ceil(qty * req) * base;
        }
      });
    }
    return isNaN(total) || total <= 0 ? null : { qty: qty, total: total };
  }

  function calcVariantPrice(products, area) {
    if (!products || !products.length || area <= 0) return null;
    var valid = products.filter(function (p) {
      return !p.excluded && parseFloat(p.coverage) > 0 && !isNaN(parseFloat(p.price));
    });
    if (!valid.length) return null;
    var groups = {};
    valid.forEach(function (p) {
      var key = p.name.replace(/\s*\(\d+.*?\)/, '').trim();
      if (!groups[key]) groups[key] = [];
      groups[key].push(p);
    });
    var sum = 0;
    var lines = [];
    Object.keys(groups).forEach(function (key) {
      var best = groups[key].reduce(function (a, b) {
        return parseFloat(a.coverage) >= parseFloat(b.coverage) ? a : b;
      });
      var r = calcProductPrice(best, area);
      if (r) {
        sum += r.total;
        lines.push({
          name: best.name,
          variant: best.variant_name || '',
          qty: r.qty,
          total: r.total,
        });
      }
    });
    return sum > 0 ? { total: sum, lines: lines } : null;
  }

  function RelentlessKitBuilder(root) {
    this.root = root;
    this.currency = root.getAttribute('data-currency') || 'EUR';
    this.kit = null;
    this.teintes = [];
    this.stepIndex = 0;
    this.selections = {};
    this.areas = { floor: 0, wall: 0 };
    this.upgradeAdded = false;
    this.tracker = root.querySelector('[data-rkb-tracker]');
    this.nav = root.querySelector('[data-rkb-nav]');
    this.navWrap = root.querySelector('.kit-nav');
    this.cartBody = root.querySelector('[data-rkb-cart-body]');
    this.totalEl = root.querySelector('[data-rkb-total]');
    this.cartNote = root.querySelector('[data-rkb-cart-note]');
    this.addBtn = root.querySelector('[data-rkb-add-cart]');
    this.colourOverlay = root.querySelector('[data-rkb-colour-overlay]');
    this.colourDetail = root.querySelector('[data-rkb-colour-detail]');
  }

  RelentlessKitBuilder.prototype.init = function () {
    var self = this;
    var kitUrl = this.root.getAttribute('data-kit-config');
    var teintesUrl = this.root.getAttribute('data-teintes-config');
    this.tracker.innerHTML = '<div class="rkb-loading">Chargement du configurateur</div>';

    Promise.all([
      fetch(kitUrl).then(function (r) {
        return r.json();
      }),
      fetch(teintesUrl).then(function (r) {
        return r.json();
      }),
    ])
      .then(function (res) {
        self.kit = res[0];
        self.teintes = res[1];
        self.buildSlides();
        self.buildNav();
        self.bindEvents();
        self.goToStep(0);
        self.updatePricing();
        if (self.navWrap) self.navWrap.hidden = false;
        self.cartNote.textContent =
          'Mode test : les prix reprennent la logique Relentless (couverture m²). Connexion panier Biocemento à venir.';
      })
      .catch(function (err) {
        console.error(err);
        self.tracker.innerHTML =
          '<p class="rkb-loading">Impossible de charger le configurateur.</p>';
      });
  };

  RelentlessKitBuilder.prototype.optionsForStep = function (step) {
    return (this.kit.options || []).filter(function (o) {
      return o.step === step;
    });
  };

  RelentlessKitBuilder.prototype.buildSlides = function () {
    var self = this;
    var kit = this.kit;
    var html = '';

    html += this.slideSize(kit);
    html += this.slideOptions('effect', 'Choisir l\'effet', kit);
    html += this.slideColours(kit);
    html += this.slideOptions('primer-area-one', 'Choisir le primaire — Sol', kit);
    html += this.slideOptions('primer-area-two', 'Choisir le primaire — Murs & plafonds', kit);
    html += this.slideOptions('finish', 'Choisir la finition', kit);
    html += this.slideUpgrade(kit);

    this.tracker.innerHTML = html;
    this.tracker.style.width = STEP_ORDER.length * 100 + '%';
    Array.from(this.tracker.querySelectorAll('.kit-slide')).forEach(function (el) {
      el.style.flex = '0 0 ' + 100 / STEP_ORDER.length + '%';
      el.style.minWidth = 100 / STEP_ORDER.length + '%';
    });

    var titleEl = this.root.querySelector('[data-rkb-kit-title]');
    if (titleEl) titleEl.textContent = kit.title || kit.title_en || 'Kit';

    this.tracker.querySelectorAll('.kit-tiles button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.selectOption(btn);
      });
    });

    this.tracker.querySelectorAll('[data-colour-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.selectColour(btn);
      });
    });

    var search = this.tracker.querySelector('[data-rkb-colour-search]');
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.toLowerCase();
        self.tracker.querySelectorAll('[data-colour-id]').forEach(function (b) {
          var name = (b.getAttribute('data-name') || '').toLowerCase();
          b.hidden = q && name.indexOf(q) === -1;
        });
      });
    }
  };

  RelentlessKitBuilder.prototype.slideHeader = function (title, kit) {
    return (
      '<div class="text"><h2>' +
      title +
      '</h2><h3>' +
      (kit.title_en || kit.title || '') +
      '</h3></div>'
    );
  };

  RelentlessKitBuilder.prototype.slideSize = function (kit) {
    return (
      '<div class="kit-slide" data-rkb-step="size">' +
      '<div class="text"><h2>Nombre de m²</h2><h3>' +
      (kit.title_en || kit.title) +
      '</h3><p>Indiquez les surfaces à traiter. Le kit s\'ajuste automatiquement.</p></div>' +
      '<div class="kit-inner-wrapper size">' +
      '<div class="size-wrapper">' +
      '<div class="input-group"><label>Surface sol</label>' +
      '<div class="input-wrapper"><input type="number" min="0" step="0.1" data-area="area-one" placeholder="Surface sol" />' +
      '<span>m<sup>2</sup></span></div></div>' +
      '<div class="input-group"><label>Surface murs & plafonds</label>' +
      '<div class="input-wrapper"><input type="number" min="0" step="0.1" data-area="area-two" placeholder="Murs & plafonds" />' +
      '<span>m<sup>2</sup></span></div></div>' +
      this.toolbar(0) +
      '</div></div></div>'
    );
  };

  RelentlessKitBuilder.prototype.slideOptions = function (step, title, kit) {
    var opts = this.optionsForStep(step);
    var tiles = opts
      .map(function (o) {
        var badgeClass = /professional/i.test(o.badge) ? 'pro-only' : 'diy-prof';
        var img = o.image
          ? '<img src="' + o.image + '" alt="" loading="lazy" />'
          : '<div class="rkb-swatch" style="background:#e8e4de"></div>';
        return (
          '<button type="button" data-step="' +
          step +
          '" data-option-id="' +
          o.id +
          '" data-skus="' +
          encodeSkus(o.skus) +
          '" aria-pressed="false">' +
          (o.badge ? '<h3 class="' + badgeClass + '">' + o.badge + '</h3>' : '') +
          '<div class="picture-wrapper">' +
          img +
          '</div>' +
          '<p>' +
          o.title +
          ' ' +
          ARROW_SVG +
          '</p></button>'
        );
      })
      .join('');

    var idx = STEP_ORDER.indexOf(step);
    return (
      '<div class="kit-slide" data-rkb-step="' +
      step +
      '">' +
      '<div class="text"><h2>' +
      title +
      '</h2><h3>' +
      (kit.title_en || kit.title) +
      '</h3><p>Cliquez sur une option pour en savoir plus — comme sur Relentless.</p></div>' +
      '<div class="kit-inner-wrapper"><div class="single-choice"><div class="kit-tiles mob-strip">' +
      tiles +
      '</div></div>' +
      this.toolbar(idx) +
      '</div></div>'
    );
  };

  RelentlessKitBuilder.prototype.slideColours = function (kit) {
    var tiles = this.teintes
      .map(function (t) {
        return (
          '<button type="button" data-colour-id="' +
          t.slug +
          '" data-name="' +
          t.name +
          ' ' +
          t.num +
          '" data-search="' +
          (t.name + ' ' + t.num).toLowerCase() +
          '" aria-pressed="false">' +
          '<div class="picture-wrapper"><div class="rkb-swatch" style="background:' +
          t.hex +
          '"></div></div>' +
          '<h3>' +
          t.name +
          ' <span>' +
          t.num +
          '</span> ' +
          ARROW_SVG +
          '</h3></button>'
        );
      })
      .join('');

    var idx = STEP_ORDER.indexOf('colour');
    return (
      '<div class="kit-slide" data-rkb-step="colour">' +
      '<div class="text"><h2>Choisir la couleur</h2><h3>' +
      (kit.title_en || kit.title) +
      '</h3><p>Nuancier Biocemento — présentation identique au sélecteur Relentless.</p></div>' +
      '<div class="colour-search"><input type="search" placeholder="Rechercher une teinte…" data-rkb-colour-search /></div>' +
      '<div class="kit-inner-wrapper"><div class="kit-scroll-wrapper colour-scroll mobile">' +
      '<div class="kit-tiles mob-strip" id="colour-select">' +
      tiles +
      '</div></div>' +
      this.toolbar(idx) +
      '</div></div>'
    );
  };

  RelentlessKitBuilder.prototype.slideUpgrade = function (kit) {
    var idx = STEP_ORDER.indexOf('upgrade');
    return (
      '<div class="kit-slide" data-rkb-step="upgrade">' +
      '<div class="text"><h2>Améliorer votre kit</h2><h3>' +
      (kit.title_en || kit.title) +
      '</h3><p>Passez en Microne Plus pour plus de résistance — équivalent Relentless.</p></div>' +
      '<div class="kit-inner-wrapper"><div class="upgrade-container">' +
      '<div class="upgrade-option" data-rkb-upgrade>' +
      '<h4>Microne → Microne Plus</h4>' +
      '<p>Renforce résistance aux taches, chocs et chaleur (sol chauffant).</p>' +
      '<button type="button" class="btn-add" data-rkb-upgrade-toggle>Ajouter</button>' +
      '</div></div>' +
      this.toolbar(idx, 'Voir le récapitulatif') +
      '</div></div>'
    );
  };

  RelentlessKitBuilder.prototype.toolbar = function (stepIndex, label) {
    label = label || 'Continuer';
    return (
      '<div class="tool-bar"><button type="button" class="btn arrow disabled" data-rkb-continue data-step-index="' +
      stepIndex +
      '" disabled><span>' +
      label +
      '</span>' +
      CONTINUE_ARROW +
      '</button></div>'
    );
  };

  RelentlessKitBuilder.prototype.buildNav = function () {
    var self = this;
  this.nav.innerHTML = STEP_ORDER.map(function (step, i) {
      return (
        '<li><button type="button" data-rkb-nav-step="' +
        i +
        '">' +
        (STEP_LABELS[step] || step) +
        '</button></li>'
      );
    }).join('');

    this.nav.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-rkb-nav-step'), 10);
        if (idx <= self.maxReachableStep()) self.goToStep(idx);
      });
    });
  };

  RelentlessKitBuilder.prototype.bindEvents = function () {
    var self = this;

    this.tracker.querySelectorAll('[data-area]').forEach(function (input) {
      input.addEventListener('input', function () {
        self.areas.floor =
          parseFloat(self.tracker.querySelector('[data-area="area-one"]').value) || 0;
        self.areas.wall =
          parseFloat(self.tracker.querySelector('[data-area="area-two"]').value) || 0;
        self.syncCalculatorInputs();
        self.updateContinueButtons();
        self.updatePricing();
      });
    });

    this.tracker.querySelectorAll('[data-rkb-continue]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-step-index'), 10);
        if (idx < STEP_ORDER.length - 1) self.goToStep(idx + 1);
        else self.updatePricing();
      });
    });

    this.root.querySelector('[data-rkb-reset]').addEventListener('click', function () {
      self.reset();
    });

    this.root.querySelector('[data-rkb-close]').addEventListener('click', function () {
      if (window.history.length > 1) window.history.back();
    });

    var upToggle = this.tracker.querySelector('[data-rkb-upgrade-toggle]');
    if (upToggle) {
      upToggle.addEventListener('click', function () {
        self.upgradeAdded = !self.upgradeAdded;
        var wrap = self.tracker.querySelector('[data-rkb-upgrade]');
        wrap.classList.toggle('is-added', self.upgradeAdded);
        upToggle.textContent = self.upgradeAdded ? 'Retirer' : 'Ajouter';
        self.updatePricing();
      });
    }

    if (this.colourOverlay) {
      this.root.querySelector('[data-rkb-colour-close]').addEventListener('click', function () {
        self.colourOverlay.hidden = true;
      });
      this.colourOverlay.addEventListener('click', function (e) {
        if (e.target === self.colourOverlay) self.colourOverlay.hidden = true;
      });
    }

    this.addBtn.addEventListener('click', function () {
      alert(
        'Mode test : le panier Shopify sera connecté une fois les variantes kits créées dans le catalogue.'
      );
    });
  };

  RelentlessKitBuilder.prototype.selectOption = function (btn) {
    var step = btn.getAttribute('data-step');
    var skusRaw = btn.getAttribute('data-skus');
    var skus = skusRaw ? JSON.parse(decodeURIComponent(skusRaw)) : null;
    this.tracker
      .querySelectorAll('button[data-step="' + step + '"]')
      .forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
    this.selections[step] = {
      id: btn.getAttribute('data-option-id'),
      title: btn.querySelector('p') ? btn.querySelector('p').textContent.trim() : '',
      skus: skus,
    };
    this.syncCalculatorInputs();
    this.updateContinueButtons();
    this.updatePricing();
  };

  RelentlessKitBuilder.prototype.selectColour = function (btn) {
    var slug = btn.getAttribute('data-colour-id');
    var name = btn.getAttribute('data-name');
    this.tracker.querySelectorAll('[data-colour-id]').forEach(function (b) {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
    this.selections.colour = { id: slug, title: name };
    var teinte = this.teintes.find(function (t) {
      return t.slug === slug;
    });
    if (teinte && this.colourDetail) {
      this.colourDetail.innerHTML =
        '<div class="rkb-detail-swatch" style="background:' +
        teinte.hex +
        '"></div><h2>' +
        teinte.name +
        ' ' +
        teinte.num +
        '</h2><p><strong>' +
        (teinte.tagline || '') +
        '</strong></p><p>' +
        (teinte.copy || '') +
        '</p>';
      this.colourOverlay.hidden = false;
    }
    this.syncCalculatorInputs();
    this.updateContinueButtons();
    this.updatePricing();
  };

  RelentlessKitBuilder.prototype.syncCalculatorInputs = function () {
    var calc = document.getElementById('calculator');
    if (!calc) return;
    var a1 = calc.querySelector('#size-area-one');
    var a2 = calc.querySelector('#size-area-two');
    var size = calc.querySelector('#size');
    if (a1) a1.value = this.areas.floor || '';
    if (a2) a2.value = this.areas.wall || '';
    if (size) size.value = (this.areas.floor || 0) + (this.areas.wall || 0);
    var colour = calc.querySelector('#colour');
    if (colour && this.selections.colour) colour.value = this.selections.colour.title;
  };

  RelentlessKitBuilder.prototype.areaForStep = function (step) {
    if (step === 'primer-area-one' || step === 'effect') return this.areas.floor;
    if (step === 'primer-area-two' || step === 'finish') return this.areas.wall;
    return this.areas.floor + this.areas.wall;
  };

  RelentlessKitBuilder.prototype.updatePricing = function () {
    var self = this;
    var rows = [];
    var grand = 0;

    ['effect', 'primer-area-one', 'primer-area-two', 'finish'].forEach(function (step) {
      var sel = self.selections[step];
      if (!sel || !sel.skus) return;
      var area = self.areaForStep(step);
      if (area <= 0) return;
      var products = sel.skus['product-info'] || sel.skus;
      var result = calcVariantPrice(Array.isArray(products) ? products : [], area);
      if (!result) return;
      result.lines.forEach(function (line) {
        rows.push({
          component: line.name,
          choice: sel.title,
          qty: line.qty,
          cost: line.total,
        });
        grand += line.total;
      });
    });

    if (this.upgradeAdded) {
      rows.push({
        component: 'Upgrade Microne Plus',
        choice: 'Option performance',
        qty: 1,
        cost: 45,
      });
      grand += 45;
    }

    if (this.selections.colour) {
      rows.push({
        component: 'Teinte',
        choice: this.selections.colour.title,
        qty: '—',
        cost: null,
      });
    }

    this.cartBody.innerHTML = rows.length
      ? rows
          .map(function (r) {
            return (
              '<tr><td>' +
              r.component +
              '</td><td>' +
              r.choice +
              '</td><td>' +
              r.qty +
              '</td><td>' +
              (r.cost != null ? formatMoney(r.cost, self.currency) : '—') +
              '</td></tr>'
            );
          })
          .join('')
      : '<tr><td colspan="4" style="opacity:0.5">Complétez les étapes pour voir le détail</td></tr>';

    this.totalEl.innerHTML = '<strong>' + formatMoney(grand, this.currency) + '</strong>';

    var ready =
      this.areas.floor + this.areas.wall > 0 &&
      this.selections.effect &&
      this.selections.colour &&
      this.selections['primer-area-one'] &&
      this.selections['primer-area-two'] &&
      this.selections.finish;

    this.addBtn.disabled = !ready;
  };

  RelentlessKitBuilder.prototype.updateContinueButtons = function () {
    var self = this;
    STEP_ORDER.forEach(function (step, i) {
      var btn = self.tracker.querySelector('[data-rkb-continue][data-step-index="' + i + '"]');
      if (!btn) return;
      var ok = self.isStepComplete(step);
      btn.disabled = !ok;
      btn.classList.toggle('disabled', !ok);
    });
  };

  RelentlessKitBuilder.prototype.isStepComplete = function (step) {
    if (step === 'size') return this.areas.floor + this.areas.wall > 0;
    if (step === 'colour') return !!this.selections.colour;
    if (step === 'upgrade') return true;
    return !!this.selections[step];
  };

  RelentlessKitBuilder.prototype.maxReachableStep = function () {
    for (var i = STEP_ORDER.length - 1; i >= 0; i--) {
      if (this.isStepComplete(STEP_ORDER[i])) return Math.min(i + 1, STEP_ORDER.length - 1);
    }
    return 0;
  };

  RelentlessKitBuilder.prototype.goToStep = function (index) {
    this.stepIndex = index;
    var offset = (index * 100) / STEP_ORDER.length;
    this.tracker.style.transform = 'translateX(-' + offset + '%)';
    this.nav.querySelectorAll('button').forEach(function (btn, i) {
      btn.classList.toggle('is-active', i === index);
      btn.classList.toggle('is-done', i < index);
    });
    this.updateContinueButtons();
  };

  RelentlessKitBuilder.prototype.reset = function () {
    this.selections = {};
    this.areas = { floor: 0, wall: 0 };
    this.upgradeAdded = false;
    this.tracker.querySelectorAll('.is-selected').forEach(function (el) {
      el.classList.remove('is-selected');
      el.setAttribute('aria-pressed', 'false');
    });
    this.tracker.querySelectorAll('[data-area]').forEach(function (inp) {
      inp.value = '';
    });
    var up = this.tracker.querySelector('[data-rkb-upgrade]');
    if (up) up.classList.remove('is-added');
    var upBtn = this.tracker.querySelector('[data-rkb-upgrade-toggle]');
    if (upBtn) upBtn.textContent = 'Ajouter';
    this.goToStep(0);
    this.updatePricing();
  };

  function encodeSkus(skus) {
    return encodeURIComponent(JSON.stringify(skus));
  }

  function boot() {
    var root = document.querySelector('[data-rkb-root]');
    if (!root) return;
    function start() {
      if (typeof jQuery === 'undefined') {
        setTimeout(start, 50);
        return;
      }
      var builder = new RelentlessKitBuilder(root);
      builder.init();
      window.MicrocementCalculator = {
        selections: builder.selections,
        updateSelection: function () {},
        reset: function () {
          builder.reset();
        },
      };
      window.KitPricing = {
        updateAllPricing: function () {
          builder.updatePricing();
        },
        resetPricing: function () {
          builder.updatePricing();
        },
      };
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  }

  boot();
})();
